import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '@/views/index.vue'
import HomeView from '@/views/website/home.vue'
import Product from '@/views/website/product.vue'
import Community from '@/views/website/community.vue'
import Question from '@/views/website/question.vue'
import UserManual from '@/views/website/userManual.vue'
import About from '@/views/website/about.vue'
import Terms from '@/views/website/terms.vue'
import Privacy from '@/views/website/privacy.vue'
import AdoptionCenter from '@/views/website/adoptionCenter.vue'
import Introduction from '@/views/website/Introduction.vue'
import ThreeDimensionalPersonality from '@/views/website/threeDimensionalPersonality.vue'

import HomeView_h5 from '@/views/mobile/home_h5.vue'
import Product_h5 from '@/views/mobile/product_h5.vue'
import Community_h5 from '@/views/mobile/community_h5.vue'
import Question_h5 from '@/views/mobile/question_h5.vue'
import UserManual_h5 from '@/views/mobile/userManual_h5.vue'
import About_h5 from '@/views/mobile/about_h5.vue'
import Terms_h5 from '@/views/mobile/terms_h5.vue'
import Privacy_h5 from '@/views/mobile/privacy_h5.vue'
import Introduction_h5 from '@/views/mobile/Introduction_h5.vue'

Vue.use(VueRouter)

export const constantRouterMap = [
  {
    path: '/',
    component: Index
  },
  // PC端
  {
    path: '/website/home',
    component: HomeView,
    name: 'home',
  },
  {
    path: '/website/product',
    component: Product,
    name: 'product',
  },
  {
    path: '/website/community',
    component: Community,
    name: 'community',
  },
  {
    path: '/website/question',
    component: Question,
    name: 'question',
  },
  {
    path: '/website/question/userManual',
    component: UserManual,
    name: 'userManual',
  },
  {
    path: '/website/about',
    component: About,
    name: 'about',
  },
  {
    path: '/website/terms',
    component: Terms,
    name: 'terms',
  },
  {
    path: '/website/privacy',
    component: Privacy,
    name: 'privacy',
  },
  {
    path: '/website/adoptionCenter',
    component: AdoptionCenter,
    name: 'adoptionCenter',
  },
  {
    path: '/website/Introduction',
    component: Introduction,
    name: 'Introduction',
  },
  {
    path: '/website/threeDimensionalPersonality',
    component: ThreeDimensionalPersonality,
    name: 'threeDimensionalPersonality',
  },
  // 移动端
  {
    path: '/mobile/home',
    component: HomeView_h5,
    name: 'home_h5',
  },
  {
    path: '/mobile/product',
    component: Product_h5,
    name: 'product_h5',
  },
  {
    path: '/mobile/community',
    component: Community_h5,
    name: 'community_h5',
  },
  {
    path: '/mobile/question',
    component: Question_h5,
    name: 'question_h5',
  },
  {
    path: '/mobile/question/userManual',
    component: UserManual_h5,
    name: 'userManual_h5',
  },
  {
    path: '/mobile/about',
    component: About_h5,
    name: 'about_h5',
  },
  {
    path: '/mobile/terms',
    component: Terms_h5,
    name: 'terms_h5',
  },
  {
    path: '/mobile/privacy',
    component: Privacy_h5,
    name: 'privacy_h5',
  },
  {
    path: '/mobile/Introduction_h5',
    component: Introduction_h5,
    name: 'Introduction_h5',
  },
  {
    path: '/mobile/threeDimensionalPersonality',
    component: ThreeDimensionalPersonality,
    name: 'threeDimensionalPersonality',
  },
]

const router = new VueRouter({
  // 使用 history 模式（需要后端配置）
  mode: 'history',
  // 基础路径，如果你的应用部署在子路径下
  base: process.env.BASE_URL,
  // 路由配置
  routes: constantRouterMap,
  // 滚动行为
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

// 3. 核心解决方案：重写 push 和 replace 方法
// 保存原始的 push 方法
const originalPush = VueRouter.prototype.push;
// 保存原始的 replace 方法
const originalReplace = VueRouter.prototype.replace;

/**
 * 重写 push 方法
 * 解决重复导航到当前路由的错误
 * @param {Object|String} location - 路由位置
 * @param {Function} onResolve - 成功回调
 * @param {Function} onReject - 失败回调
 */
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  // 如果传入了 onResolve 或 onReject 回调
  if (onResolve || onReject) {
    // 使用原始 push 方法，并传入回调
    return originalPush.call(this, location, onResolve, onReject);
  }

  // 没有回调时，使用原始 push 并捕获重复导航错误
  return originalPush.call(this, location).catch(err => {
    // 如果是重复导航错误，忽略它
    if (err.name !== 'NavigationDuplicated') {
      // 其他错误正常抛出
      throw err;
    }
    // 可以在这里添加日志记录（开发环境）
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Router] 重复导航已忽略: ${typeof location === 'object' ? location.path || location.name : location}`);
    }
  });
};

/**
 * 重写 replace 方法
 * @param {Object|String} location - 路由位置
 * @param {Function} onResolve - 成功回调
 * @param {Function} onReject - 失败回调
 */
VueRouter.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalReplace.call(this, location, onResolve, onReject);
  }

  return originalReplace.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err;
    }
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Router] 重复替换导航已忽略: ${typeof location === 'object' ? location.path || location.name : location}`);
    }
  });
};

// 4. 添加路由守卫（可选，用于进一步控制）
// 全局前置守卫
router.beforeEach((to, from, next) => {
  // 设置页面标题
  if (to.meta.title) {
    document.title = to.meta.title;
  }

  // 检查是否需要登录认证
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // 这里检查用户是否已登录
    const isAuthenticated = checkAuth(); // 实现你的认证检查逻辑

    if (!isAuthenticated) {
      // 未登录，重定向到登录页
      next({
        path: '/login',
        query: { redirect: to.fullPath }  // 保存目标路由，登录后跳转
      });
      return;
    }
  }

  // 防止重复导航的额外检查（可选）
  if (to.path === from.path && to.name === from.name) {
    // 相同的路由，但参数可能不同
    if (JSON.stringify(to.params) !== JSON.stringify(from.params) ||
      JSON.stringify(to.query) !== JSON.stringify(from.query)) {
      // 参数不同，允许跳转
      next();
    } else {
      // 完全相同的路由，可以阻止或记录
      if (process.env.NODE_ENV === 'development') {
        console.log(`[Router] 阻止重复导航: ${to.path}`);
      }
      // next(false); // 阻止导航
      next(); // 或者允许，但会被上面的 push 方法捕获
    }
  } else {
    next();
  }
});

// 全局解析守卫
router.beforeResolve((to, from, next) => {
  // 可以在这里进行一些数据预取等操作
  next();
});

// 全局后置钩子
router.afterEach(() => {
  // to, from
  // 可以在这里进行页面访问统计等
  if (process.env.NODE_ENV === 'production') {
    // 发送页面浏览统计
    // trackPageView(to.path);
  }
});

// 5. 辅助函数
function checkAuth() {
  // 实现你的认证检查逻辑
  // 例如检查 localStorage 中是否有 token
  return !!localStorage.getItem('token');
}

// 6. 错误处理
router.onError((error) => {
  const pattern = /Loading chunk (\w)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);

  if (isChunkLoadFailed) {
    // 动态导入的组件加载失败，可能是网络问题
    // 可以刷新页面或显示错误提示
    location.reload();
  }

  console.error('[Router Error]', error);
});

// 7. 导出 router 实例
export default router;